import {
	Add,
	Announce,
	Archive,
	ArrowDown,
	ArrowLeft,
	ArrowRight,
	ArrowUp,
	At,
	Attach,
	Bank,
	Bookmark,
	Bug,
	Building,
	Calendar,
	Cancel,
	Card,
	Cat,
	Chat,
	Check,
	ChevronDoubleLeft,
	ChevronDoubleRight,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	Close,
	Copy,
	CurrencyCredit,
	CurrencyDollar,
	CurrencyEuro,
	CurrencyExchange,
	CurrencyLivres,
	CurrencyMoney,
	CurrencyYen,
	Dashboard,
	DataBar,
	DataHealth,
	DataStock,
	DataTimeline,
	Desktop,
	Document,
	DotArrow,
	Dot,
	DoubleCheck,
	Download,
	EditDoc,
	EditInline,
	Exchange,
	Filter,
	Finger,
	Flag,
	Flash,
	Folder,
	Fx,
	Gauge,
	HeartEmpty,
	HeartFilled,
	Home,
	Iban,
	Ibanfirst,
	Id,
	Image,
	IndicatorAlert,
	IndicatorHelp,
	IndicatorInfo,
	IndicatorWarning,
	Launch,
	Link,
	List,
	Location,
	LockClosed,
	LockOpen,
	Logout,
	Mail,
	Minus,
	MobileSend,
	Mobile,
	Notification,
	Ocr,
	Office,
	Open,
	Org,
	OsAndroid,
	OsApple,
	ParameterH,
	ParameterV,
	PaymentFlexible,
	PaymentForward,
	Phone,
	PhotoOff,
	Photo,
	Receipt,
	Reduce,
	Save,
	Search,
	Security,
	Send,
	Services,
	Settings,
	Share,
	ShieldLock,
	ShieldTimeline,
	SignCheck,
	SignDoc,
	Skull,
	StarFilled,
	StarMinus,
	StarPlus,
	TagEmpty,
	TagFilled,
	Team,
	Time,
	Trash,
	TriangleDown,
	TriangleLeft,
	TriangleRight,
	TriangleUp,
	Upload2,
	Upload,
	Usb,
	User,
	ViewEmpty,
	ViewFilled,
	ViewOff,
	WalletFilled,
	WalletLine,
	Ways,
	ZoomMinus,
	ZoomPlus
} from './js'

const IconMap = {
	add: Add,
	announce: Announce,
	archive: Archive,
	'arrow-down': ArrowDown,
	'arrow-left': ArrowLeft,
	'arrow-right': ArrowRight,
	'arrow-up': ArrowUp,
	at: At,
	attach: Attach,
	bank: Bank,
	bookmark: Bookmark,
	bug: Bug,
	building: Building,
	calendar: Calendar,
	cancel: Cancel,
	card: Card,
	cat: Cat,
	chat: Chat,
	check: Check,
	'chevron-double-left': ChevronDoubleLeft,
	'chevron-double-right': ChevronDoubleRight,
	'chevron-down': ChevronDown,
	'chevron-left': ChevronLeft,
	'chevron-right': ChevronRight,
	'chevron-up': ChevronUp,
	close: Close,
	copy: Copy,
	'currency-credit': CurrencyCredit,
	'currency-dollar': CurrencyDollar,
	'currency-euro': CurrencyEuro,
	'currency-exchange': CurrencyExchange,
	'currency-livres': CurrencyLivres,
	'currency-money': CurrencyMoney,
	'currency-yen': CurrencyYen,
	dashboard: Dashboard,
	'data-bar': DataBar,
	'data-health': DataHealth,
	'data-stock': DataStock,
	'data-timeline': DataTimeline,
	desktop: Desktop,
	document: Document,
	'dot-arrow': DotArrow,
	dot: Dot,
	'double-check': DoubleCheck,
	download: Download,
	'edit-doc': EditDoc,
	'edit-inline': EditInline,
	exchange: Exchange,
	filter: Filter,
	finger: Finger,
	flag: Flag,
	flash: Flash,
	folder: Folder,
	fx: Fx,
	gauge: Gauge,
	'heart-empty': HeartEmpty,
	'heart-filled': HeartFilled,
	home: Home,
	iban: Iban,
	ibanfirst: Ibanfirst,
	id: Id,
	image: Image,
	'indicator-alert': IndicatorAlert,
	'indicator-help': IndicatorHelp,
	'indicator-info': IndicatorInfo,
	'indicator-warning': IndicatorWarning,
	launch: Launch,
	link: Link,
	list: List,
	location: Location,
	'lock-closed': LockClosed,
	'lock-open': LockOpen,
	logout: Logout,
	mail: Mail,
	minus: Minus,
	'mobile-send': MobileSend,
	mobile: Mobile,
	notification: Notification,
	ocr: Ocr,
	office: Office,
	open: Open,
	org: Org,
	'os-android': OsAndroid,
	'os-apple': OsApple,
	'parameter-h': ParameterH,
	'parameter-v': ParameterV,
	'payment-flexible': PaymentFlexible,
	'payment-forward': PaymentForward,
	phone: Phone,
	'photo-off': PhotoOff,
	photo: Photo,
	receipt: Receipt,
	reduce: Reduce,
	save: Save,
	search: Search,
	security: Security,
	send: Send,
	services: Services,
	settings: Settings,
	share: Share,
	'shield-lock': ShieldLock,
	'shield-timeline': ShieldTimeline,
	'sign-check': SignCheck,
	'sign-doc': SignDoc,
	skull: Skull,
	'star-filled': StarFilled,
	'star-minus': StarMinus,
	'star-plus': StarPlus,
	'tag-empty': TagEmpty,
	'tag-filled': TagFilled,
	team: Team,
	time: Time,
	trash: Trash,
	'triangle-down': TriangleDown,
	'triangle-left': TriangleLeft,
	'triangle-right': TriangleRight,
	'triangle-up': TriangleUp,
	'upload-2': Upload2,
	upload: Upload,
	usb: Usb,
	user: User,
	'view-empty': ViewEmpty,
	'view-filled': ViewFilled,
	'view-off': ViewOff,
	'wallet-filled': WalletFilled,
	'wallet-line': WalletLine,
	ways: Ways,
	'zoom-minus': ZoomMinus,
	'zoom-plus': ZoomPlus
}

export default IconMap
